import axiosInstance from '../main/axios'; // Alterado para usar a instância configurada
import consts from '../consts'; // Adaptar caminho para seu arquivo de constantes (URL da API)
import { toastr } from 'react-redux-toastr';

export const TICKET_SUPORTE_FETCHED = 'TICKET_SUPORTE_FETCHED';
export const TICKET_SUPORTE_CREATED = 'TICKET_SUPORTE_CREATED';
export const TICKET_SUPORTE_UPDATED = 'TICKET_SUPORTE_UPDATED';
export const TICKET_SUPORTE_REQUEST_STARTED = 'TICKET_SUPORTE_REQUEST_STARTED'; // Para loading
export const TICKET_SUPORTE_REQUEST_FINISHED = 'TICKET_SUPORTE_REQUEST_FINISHED'; // Para loading

// Novas actions para interações de ticket
export const TICKET_INTERACOES_REQUEST_STARTED = 'TICKET_INTERACOES_REQUEST_STARTED';
export const TICKET_INTERACOES_FETCHED = 'TICKET_INTERACOES_FETCHED';
export const TICKET_INTERACOES_REQUEST_ERROR = 'TICKET_INTERACOES_REQUEST_ERROR';

// Novas actions para ADICIONAR interações
export const TICKET_INTERACAO_ADD_STARTED = 'TICKET_INTERACAO_ADD_STARTED';
export const TICKET_INTERACAO_ADDED_SUCCESS = 'TICKET_INTERACAO_ADDED_SUCCESS';
export const TICKET_INTERACAO_ADD_ERROR = 'TICKET_INTERACAO_ADD_ERROR';

// Novas actions para atribuição de ticket
// TICKET_ASSIGN_SUCCESS foi removido

const BASE_URL = `${consts.API_URL}/ticket_suporte`; // Ajustar endpoint da API

// Action para buscar tickets
export function fetchTickets(params = {}) {
  return dispatch => {
    dispatch({ type: TICKET_SUPORTE_REQUEST_STARTED });
    return axiosInstance.get(BASE_URL, { params })
      .then(response => {
        dispatch({ type: TICKET_SUPORTE_FETCHED, payload: response.data }); // Supondo que a API retorna { data: [tickets], meta: {pagination} }
        dispatch({ type: TICKET_SUPORTE_REQUEST_FINISHED });
        return response.data; // Retornar os dados para o componente se necessário
      })
      .catch(error => {
        toastr.error('Erro', 'Falha ao buscar tickets.');
        console.error('Erro fetchTickets:', error.response || error.message || error);
        dispatch({ type: TICKET_SUPORTE_REQUEST_FINISHED });
        throw error; // Propagar o erro para o componente poder tratar se quiser
      });
  };
}

// Action para criar um novo ticket
export function createTicket(ticketData) {
  return dispatch => {
    dispatch({ type: TICKET_SUPORTE_REQUEST_STARTED });

    const finalTicketData = {
      ...ticketData,
      controlador_id: ticketData.controlador_id || null,
      controlador_erro_id: ticketData.controlador_erro_id || null,
      usuario_atribuido_id: null // Campo não será mais usado para atribuição, garantir que seja null
    };

    return axiosInstance.post(BASE_URL, finalTicketData)
      .then(response => {
        dispatch({ type: TICKET_SUPORTE_CREATED, payload: response.data }); 
        dispatch({ type: TICKET_SUPORTE_REQUEST_FINISHED });
        return response.data; 
      })
      .catch(error => {
        toastr.error('Erro', 'Falha ao criar ticket.');
        console.error('Erro createTicket:', error.response || error.message || error);
        dispatch({ type: TICKET_SUPORTE_REQUEST_FINISHED });
        throw error;
      });
  };
}

// Action para atualizar um ticket existente
export function updateTicket(ticketData) {
  return dispatch => {
    dispatch({ type: TICKET_SUPORTE_REQUEST_STARTED });

    // Remover usuario_atribuido_id do payload de update, pois não é mais gerenciado dessa forma
    const { usuario_atribuido_id, ...restOfTicketData } = ticketData;
    const finalTicketData = {
        ...restOfTicketData, // Usa o resto dos dados
        controlador_id: ticketData.controlador_id || null,
    };

    return axiosInstance.put(`${BASE_URL}/${finalTicketData.id}`, finalTicketData)
      .then(response => {
        dispatch({ type: TICKET_SUPORTE_UPDATED, payload: response.data });
        dispatch({ type: TICKET_SUPORTE_REQUEST_FINISHED });
        return response.data; 
      })
      .catch(error => {
        toastr.error('Erro', 'Falha ao atualizar ticket.');
        console.error('Erro updateTicket:', error.response || error.message || error);
        dispatch({ type: TICKET_SUPORTE_REQUEST_FINISHED });
        throw error;
      });
  };
}

// Action para criar um ticket a partir de um erro de controlador
export function createTicketFromError(controladorErroId, erroInfo) {
    return dispatch => {
        dispatch({ type: TICKET_SUPORTE_REQUEST_STARTED });
        
        const ticketData = {
            titulo: `Erro no Ctrl ${erroInfo.controlador_id || '?'} - ${erroInfo.mensagem_erro ? erroInfo.mensagem_erro.substring(0, 40) : 'Detalhes pendentes'}...`,
            descricao: `Erro original: ${erroInfo.mensagem_erro || 'N/A'}\nData do erro: ${erroInfo.data_erro || 'N/A'} ${erroInfo.hora_erro || 'N/A'}\nID do Erro no Sistema: ${controladorErroId || 'N/A'}`,
            controlador_id: erroInfo.controlador_id,
            controlador_erro_id: controladorErroId, 
            status: 'ABERTO',
            usuario_atribuido_id: null // Garantir que seja null
        };
        
        return dispatch(createTicket(ticketData))
            .then(createdTicket => {
                return createdTicket; 
            })
            .catch(error => {
                throw error; 
            });
    };
} 

// A action assignTicket() foi removida daqui.

// Nova action para assumir/atribuir um ticket
// TICKET_ASSIGN_SUCCESS foi removido

// export function assignTicket(ticketId, userIdToAssign) {
//   return dispatch => {
//     dispatch({ type: TICKET_SUPORTE_REQUEST_STARTED });
//     // O backend deve popular nome_usuario_atribuido com base no ID.
//     const payload = { usuario_atribuido_id: userIdToAssign };

//     // Usaremos o mesmo endpoint de PUT para atualizar o ticket,
//     // apenas com o campo usuario_atribuido_id.
//     // Se o seu backend tiver um endpoint específico para "assign", ajuste a URL.
//     return axiosInstance.put(`${BASE_URL}/${ticketId}`, payload)
//       .then(response => {
//         // A resposta do backend DEVE ser o ticket completamente atualizado,
//         // incluindo nome_usuario_atribuido se o backend o populou.
//         dispatch({ type: TICKET_ASSIGN_SUCCESS, payload: response.data });
//         dispatch({ type: TICKET_SUPORTE_REQUEST_FINISHED });
//         return response.data; // Retorna o ticket atualizado
//       })
//       .catch(error => {
//         toastr.error('Erro', 'Falha ao assumir o ticket.');
//         console.error('Erro assignTicket:', error.response || error.message || error);
//         dispatch({ type: TICKET_SUPORTE_REQUEST_FINISHED });
//         throw error; // Propaga o erro para o componente poder tratar se quiser
//       });
//   };
// } 

// Nova action para buscar interações de um ticket
export function fetchInteracoes(ticketId) {
  return dispatch => {
    dispatch({ type: TICKET_INTERACOES_REQUEST_STARTED, payload: { ticketId } });
    return axiosInstance.get(`${BASE_URL}/${ticketId}/interacoes`)
      .then(response => {
        dispatch({ 
          type: TICKET_INTERACOES_FETCHED, 
          payload: { ticketId, interacoes: response.data } // Assumindo que a API retorna um array de interações
        });
        return response.data; 
      })
      .catch(error => {
        toastr.error('Erro', `Falha ao buscar interações para o ticket ${ticketId}.`);
        console.error(`Erro fetchInteracoes para ticket ${ticketId}:`, error.response || error.message || error);
        dispatch({ type: TICKET_INTERACOES_REQUEST_ERROR, payload: { ticketId, error } });
        throw error; 
      });
  };
} 

// Nova action para adicionar uma interação a um ticket
export function addInteracao(ticketId, interacaoData) {
  // interacaoData deve ser um objeto como { texto_interacao: "...", tipo_interacao: "..." (opcional), privado: ... (opcional) }
  return dispatch => {
    dispatch({ type: TICKET_INTERACAO_ADD_STARTED, payload: { ticketId } });
    
    // O usuario_id será adicionado pelo backend com base no usuário autenticado
    return axiosInstance.post(`${BASE_URL}/${ticketId}/interacoes`, interacaoData)
      .then(response => {
        // Assumindo que o backend retorna a interação recém-criada (com id, data_interacao, nome_usuario preenchidos)
        dispatch({ 
          type: TICKET_INTERACAO_ADDED_SUCCESS, 
          payload: { ticketId, interacao: response.data }
        });
        toastr.success('Sucesso', 'Interação adicionada.');
        return response.data; 
      })
      .catch(error => {
        toastr.error('Erro', `Falha ao adicionar interação ao ticket ${ticketId}.`);
        console.error(`Erro addInteracao para ticket ${ticketId}:`, error.response || error.message || error);
        dispatch({ type: TICKET_INTERACAO_ADD_ERROR, payload: { ticketId, error } });
        throw error; 
      });
  };
} 